var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('BaseCard',[_c('BaseStats',{attrs:{"stats":[
        {
          value: _vm.hitRateWithUnit,
          label: _vm.label,
          icon: 'question-circle',
          iconToolTip: _vm.status.message,
          iconIssueType: _vm.status.type,
        } ]}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }